// [ServiceUp patch] Locais compilados reduzidos aos idiomas efetivamente usados
// nesta instancia (todas as contas usam pt_BR). Corta ~10MB de traducoes de 42
// idiomas do chunk inicial do dashboard, que o V8 reparseava a cada load.
// O seletor de idiomas continua vindo do backend (enabledLanguages); idiomas
// nao compilados caem no fallbackLocale 'en' definido em entrypoints/dashboard.js.
import en from './locale/en';
import es from './locale/es';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

export default {
  en,
  es,
  pt,
  pt_BR,
};
